import { defineStore } from 'pinia'
import { newCall } from '@/util/http'
import { debounce } from '@safety/shared-utils'

/**
 * 用户待办事项数量
 */
export const useTodoCountStore = defineStore('count', {
  state: () => ({
    count: 0,
    _debouncedFetch: null
  }),
  actions: {
    update(count) {
      this.count = count
    },
    async _fetchTodoCount() {
      const { code, data, message } = await newCall({ url: 'todoList/get/todoCount' })
      if (code === 0) {
        this.update(data || 0)
        return this.count
      } else {
        throw new Error(message)
      }
    },
    _getDebouncedFetch() {
      if (!this._debouncedFetch) {
        this._debouncedFetch = debounce(() => this._fetchTodoCount(), 300, true)
      }
      return this._debouncedFetch
    },
    /**
     * 从服务器获取并更新待办事项数量
     * @param {Object} options - 配置选项
     * @param {boolean} options.debounce - 是否启用防抖，默认为 false
     * @returns {Promise<number>} 返回待办事项数量
     */
    async fetchTodoCount(options = {}) {
      const { debounce = false } = options

      try {
        if (debounce) {
          const debouncedFn = this._getDebouncedFetch()
          return await debouncedFn()
        }
        return await this._fetchTodoCount()
      } catch (error) {
        console.error('[TodoCountStore] 获取待办数量失败', error)
        return this.count || 0
      }
    }
  }
})
